import getBaseUrl from "./getBaseUrl";

export default function () {
  return `${getBaseUrl()}/api`;
}
